/* スライダー */
let p_historySlider = new Swiper(".p_historySlider", {
  loop: true,
  slidesPerView: 1,
  spaceBetween: 16,
  centeredSlides: true,
  speed: 500,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    768: {
      slidesPerView: 1,
    },
  },
});

AOS.init();
